<div class="page-inner main">
    <h1>{{'IMPRINT.HEADER' | translate}}</h1>
    <p>{{'IMPRINT.TEXT' | translate}}</p>
</div>